<template>
  <v-container>
    <v-progress-circular indeterminate :size="48" />
  </v-container>
</template>

<script>
import { authService, authorize } from '@/services/AuthService';

export default {
  name: 'CallbackPage',

  async mounted() {
    const code = this.$route.query.code;
    const error = this.$route.query.error;
    const state = this.$route.query.state;

    if (!code && !error) {
      try {
        await authorize('none');
      } catch {
        await this.$router.replace('/login');
      }
      return;
    }

    if (error || !code || !state) {
      await this.$router.replace('/login');
      return;
    }

    try {
      await authService.completeAuthorization(
        code,
        state,
        window.location.origin + '/callback'
      );

      await this.$router.replace('/');
    } catch {
      await this.$router.replace('/login');
    }
  }
};
</script>